export enum ColumnDataType {
    AMOUNT = "amount",
    DATE = "date",
    STRING = "string"
  }

export type ColumnDataTypeInterface = ColumnDataType.DATE | ColumnDataType.AMOUNT | ColumnDataType.STRING
  